import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-device-details',
  templateUrl: './device-details.component.html',
  styleUrls: ['./device-details.component.scss']
})
export class DeviceDetailsComponent implements OnInit {
  temperature: number;
  fanspeed: string;
  activity: string;
  mode: string;
  tempUID: string;
  fanUID: string;
  modeUID: string;
  actUID: string;
  selectedDeviceData: any;
  showtime = false;
  startTime: string = '';
  endTime: string = '';
  timeRanges: { start: string, end: string }[] = [];
  user: any;
  token: NbAuthJWTToken;
  responseData: any;
  activateScheduling: any;

  constructor(private authService: NbAuthService, private translateService: TranslateService, private toastrService: NbToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient,
    private dialogRef: MatDialogRef<DeviceDetailsComponent>
  ) {
    this.authService.onTokenChange()
      .subscribe((token: NbAuthJWTToken) => {
        this.token = token;

        if (token.isValid()) {
          this.user = token.getPayload()['name'];
        }
      });

    this.http.get<any>('https://accept-capp.iti.gr/api/scheduledhw/?name=' + this.user).subscribe(response => {
      if (response && response.length > 0) {
        this.activateScheduling = response[0].is_executed;
        this.responseData = response;
        response.forEach(timeRange => {
          this.timeRanges.push({ start: timeRange.start_time, end: timeRange.end_time });
        });
      }
    });

    this.selectedDeviceData = data;

    for (let item of data["device_details"]) {
      switch (item.name) {
        case "temperature":
          this.temperature = item.value;
          this.tempUID = item.itemUUID;
          break;
        case "fanspeed":
          this.fanspeed = item.value;
          this.fanUID = item.itemUUID;
          break;
        case "mode":
          this.mode = item.value;
          this.modeUID = item.itemUUID;
          break;
        case "relayOutput":
          this.activity = parseInt(item.value, 10) === 1 ? 'ON' : 'OFF';
          this.actUID = item.itemUUID;
          break;
        case "status":
          this.activity = parseInt(item.value, 10) === 1 ? 'ON' : 'OFF';
          this.actUID = item.itemUUID;
          break;
        case "switchBinary":
          console.log("switchBinary",item)
          this.activity = parseInt(item.value, 10) === 1 ? 'ON' : 'OFF';
          this.actUID = item.itemUUID;
          break;
      }
    }
  }

  setName(item) {
    item.editName = true;
  }

  increment() {
    this.temperature = Math.min(31, this.temperature + 1);
  }

  decrement() {
    this.temperature = Math.max(16, this.temperature - 1);
  }

  removeTimeRange(timeRange: any) {
    if (this.activateScheduling) {
      const index = this.timeRanges.indexOf(timeRange);
      if (index !== -1) {
        this.http.get<any>('https://accept-capp.iti.gr/api/scheduledhw/?name=' + this.user).subscribe(response => {
          if (response && response.length > 0) {
            const idToRemove = response[index].id || this.responseData[index].id;
            this.http.delete('https://accept-capp.iti.gr/api/scheduledhw/?name=' + this.user + '&id=' + idToRemove).subscribe(() => {
              this.timeRanges.splice(index, 1);
            }, error => {
              console.log("Error deleting time range:", error);
            });
          }
        });
      }
    }
  }

  toggleSlide(event: MatSlideToggleChange): void {
    this.activateScheduling = !this.activateScheduling;
  }

  onFanSpeedClick(speed: string) {
    this.fanspeed = speed;
  }

  changeMode(newMode: string) {
    this.mode = newMode;
  }

  submitTimeRange() {
    if (this.activateScheduling) {
      if (this.startTime && this.endTime) {
        this.timeRanges.push({ start: this.startTime, end: this.endTime });

        this.http.post("https://accept-capp.iti.gr/api/scheduledhw/?uuid=" + this.actUID + "&start=" + this.startTime + "&end=" + this.endTime, {}).subscribe(data => {
          // console.log(data)
        })

        this.startTime = '';
        this.endTime = '';
      }
    }
  }

  ngOnInit(): void { }

  onToggleChange(event: MatSlideToggleChange): void {
    this.activity = event.checked ? 'ON' : 'OFF';
  }

  save() {
    const controls = (this.selectedDeviceData["selected_row"].name === "DHW")
      ? [{ itemUUID: this.actUID, value: this.activity, name: "switchBinary", device: this.selectedDeviceData["selected_row"].name }]
      : [
        { itemUUID: this.actUID, value: this.activity, name: "status", device: this.selectedDeviceData["selected_row"].name },
        { itemUUID: this.fanUID, value: this.fanspeed, name: "fanspeed", device: this.selectedDeviceData["selected_row"].name },
        { itemUUID: this.tempUID, value: this.temperature ? this.temperature.toString() : '0', name: "temperature", device: this.selectedDeviceData["selected_row"].name },
        { itemUUID: this.modeUID, value: this.mode, name: "mode", device: this.selectedDeviceData["selected_row"].name }
      ];

    console.log(controls);

    this.http.post('https://accept-capp.iti.gr/api/controllable/', { "controls": controls })
      .subscribe(response => {
    this.toastrService.success(this.translateService.instant('app.control-action-submitted-successfully'));
    });

    const modeValue = this.activateScheduling ? 'active' : 'inactive';
    const url = `https://accept-capp.iti.gr/api/scheduledhw/?name=${this.user}&mode=${modeValue}`;
    this.http.put(url, null).subscribe(() => {
    });

    this.close();
  }

  close() {
    this.dialogRef.close();
  }
}
